import {DragItemType, TypeOfItem} from "../../types";
import {makeArray} from "../common/makeArray";
import {randomInteger} from "../common/random";
import {generateUUID} from "../common/generateUUID";

const getItemsCount = (PANEL_SIZE_ITEM: number) => {
    const items_count: {[key in TypeOfItem]: { count: number[]; width: number }} = {
        BOMB: {
            count: makeArray(1),
            width: PANEL_SIZE_ITEM,
        },

        SINGLE: {
            count: makeArray(1),
            width: PANEL_SIZE_ITEM,
        },

        DOUBLE_COL: {
            count: makeArray(2),
            width: PANEL_SIZE_ITEM,
        },
        TRIPLE_COL: {
            count: makeArray(3),
            width: PANEL_SIZE_ITEM
        },
        FOUR_COL: {
            count: makeArray(4),
            width: PANEL_SIZE_ITEM
        },
        FIVE_COL: {
            count: makeArray(5),
            width: PANEL_SIZE_ITEM
        },

        DOUBLE_ROW: {
            count: makeArray(2),
            width: PANEL_SIZE_ITEM * 2
        },
        TRIPLE_ROW: {
            count: makeArray(3),
            width: PANEL_SIZE_ITEM * 3
        },
        FOUR_ROW: {
            count: makeArray(4),
            width: PANEL_SIZE_ITEM * 4
        },
        FIVE_ROW: {
            count: makeArray(5),
            width: PANEL_SIZE_ITEM * 5
        },

        DOUBLE_SQUARE: {
            count: makeArray(4),
            width: PANEL_SIZE_ITEM * 2
        },
        TRIPLE_SQUARE: {
            count: makeArray(9),
            width: PANEL_SIZE_ITEM * 3
        },

        MINI_ANGLE_LEFT_TOP: {
            count: makeArray(3),
            width: PANEL_SIZE_ITEM * 2
        },
        MINI_ANGLE_RIGHT_TOP: {
            count: makeArray(3),
            width: PANEL_SIZE_ITEM * 2
        },
        MINI_ANGLE_RIGHT_BOTTOM: {
            count: makeArray(3),
            width: PANEL_SIZE_ITEM * 2
        },
        MINI_ANGLE_LEFT_BOTTOM: {
            count: makeArray(3),
            width: PANEL_SIZE_ITEM * 2
        },

        ANGLE_LEFT_TOP: {
            count: makeArray(5),
            width: PANEL_SIZE_ITEM * 3
        },
        ANGLE_LEFT_BOTTOM: {
            count: makeArray(5),
            width: PANEL_SIZE_ITEM * 3
        },
        ANGLE_RIGHT_BOTTOM: {
            count: makeArray(5),
            width: PANEL_SIZE_ITEM * 3
        },
        ANGLE_RIGHT_TOP: {
            count: makeArray(5),
            width: PANEL_SIZE_ITEM * 3
        },
    }

    return items_count
}

export const getInitialDragData = (typeOfItem: TypeOfItem, PANEL_SIZE_ITEM: number, toolPanelPosition?: number): DragItemType => {
    return {
        id: generateUUID(),
        typeOfItem,
        type: "VISIBLE",
        items: getItemsCount(PANEL_SIZE_ITEM)[typeOfItem].count,
        width: getItemsCount(PANEL_SIZE_ITEM)[typeOfItem].width,
        isDisappearance: false,
        bombMovesLeft: 9,
        indexToolPanel: toolPanelPosition || 0,
    };
}

export const createRandomDragItem = (PANEL_SIZE_ITEM: number, toolPanelPosition: number) => {
    const itemKeys = Object.keys(getItemsCount(PANEL_SIZE_ITEM));

    // начинаем выбирать с первой позиции (тк на нулевой позиции бомба, её игрок не может получить для вставки)
    return getInitialDragData(itemKeys[randomInteger(1, itemKeys.length - 1)] as TypeOfItem, PANEL_SIZE_ITEM, toolPanelPosition);
}
